import { Classroom } from '@/api/classroom'

const state = () => ({
    listReviews: [],
    listReviewPagination: {},
    summaryReview: {},
    detailReview: {},
    loadingReview: false,
    isSuccessReview: true,
    messageReview: '',
    savedClassroomIdReview: 0,
})

const getters = {
    listReviews: state => state.listReviews,
    listReviewPagination: state => state.listReviewPagination,
    summaryReview: state => state.summaryReview,
    detailReview: state => state.detailReview,
    loadingReview: state => state.loadingReview,
    isSuccessReview: state => state.isSuccessReview,
    messageReview: state => state.messageReview,
    savedClassroomIdReview: state => state.savedClassroomIdReview,
}

const actions = {
    async fetchClassroomReview({commit}, query = null) {
        commit('setReviewLoading', true)
        commit('setClassroomIdReview', query.classroomId)
        let page = 1
        let perPage = 10
        if (query != null) {
            page = query.page
            perPage = query.perPage
        }
        await Classroom.getClassroomReview(query?.classroomId, page, perPage)
            .then(res => {
                commit('setReviewLoading', false)
                commit('setReviews', res.data.data)
                commit('setReviewPagination', res.data.pages)
                commit('setSummaryReview', res.data.rating)
            })
            .catch(err => {
                commit('setReviewLoading', false)
                commit('setReviewMessage', err)
            })
    },
    async fetchAllReviews({ commit }, id) {
        commit('setReviewLoading', true)
        await Classroom.reviewList(id)
            .then(res => {
                commit('setReviews', res.data.data)
                commit('setReviewPagination', res.data.pages)
                commit('setReviewLoading', false)
            })
            .catch(err => {
                console.log(err)
                commit('setReviewLoading', false)
                commit('setReviewMessage', err)
            })
    },
    async fetchDetailReview({ commit }, data) {
        commit('setReviewLoading', false)
        await Classroom.reviewDetail(data.classroom_id, data.id)
            .then(res => {
                commit('setReview', res.data.data)
                commit('setReviewLoading', false)
            })
            .catch(err => {
                console.log(err)
                commit('setReviewLoading', false)
                commit('setReviewMessage', err)
            })
    },
    async addReview({ commit }, data) {
        commit('setReviewLoading', true)
        await Classroom.reviewAdd(data.classroom_id, data.payload)
            .then(res => {
                if (res.data.success) {
                    commit('setReviewSuccess', true)
                    commit('setReviewLoading', false)
                    commit('setReviewMessage', 'Berhasil Menambahkan Review Kelas')
                } else {
                    commit('setReviewSuccess', false)
                    commit('setReviewLoading', false)
                    commit('setReviewMessage', 'Terjadi Kesalahan')
                }
            })
            .catch(err => {
                commit('setReviewSuccess', false)
                commit('setReviewLoading', false)
                commit('setReviewMessage', err.errors[0].message)
            })
    },
    async updateReview({ commit }, data) {
        commit('setReviewLoading', true)
        await Classroom.reviewUpdate(data.id, data.payload)
            .then(res => {
                if (res.data.success) {
                    commit('setReviewSuccess', true)
                    commit('setReviewLoading', false)
                    commit('setReviewMessage', 'Berhasil Mengubah Review Kelas')
                } else {
                    commit('setReviewSuccess', false)
                    commit('setReviewLoading', false)
                    commit('setReviewMessage', 'Terjadi Kesalahan')
                }
            })
            .catch(err => {
                commit('setReviewSuccess', false)
                commit('setReviewLoading', false)
                commit('setReviewMessage', err.errors[0].message)
            })
    },
    async deleteReview({ commit }, data) {
        // console.log('masuk')
        commit('setReviewLoading', true)
        await Classroom.reviewRemove(data.classroom_id, data.review_id)
            .then(res => {
                if (res.data.success) {
                    commit('setReviewSuccess', true)
                    commit('setReviewLoading', false)
                    commit('setReviewMessage', 'Berhasil Menghapus Review Kelas')
                } else {
                    commit('setReviewSuccess', false)
                    commit('setReviewLoading', false)
                    commit('setReviewMessage', 'Terjadi Kesalahan')
                }
            })
            .catch(err => {
                commit('setReviewSuccess', false)
                commit('setReviewLoading', false)
                commit('setReviewMessage', err.errors[0].message)
            })
    }
}

const mutations = {
    setReviews: (state, reviews) => {
        state.listReviews = reviews
    },
    setReviewPagination: (state, pagination) => {
        state.listReviewPagination = pagination
    },
    setSummaryReview(state, summary) {
        state.summaryReview = summary
    }, 
    setReview: (state, review) => {
        state.detailReview = review
    },
    setReviewLoading: (state, loading) => {
        state.loadingReview = loading
    },
    setReviewSuccess: (state, success) => {
        state.isSuccessReview = success
    },
    setReviewMessage: (state, message) => {
        state.messageReview = message
    },
    setClassroomIdReview(state, id) {
        state.savedClassroomIdReview = id
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}